import type { ColumnDefinition } from "../../../ui/components/Table/types";
import type { Language } from "../../lib/api/localization";
import type { TranslateValues } from "../../lib/i18n";

type TranslateFn = (key: string, values?: TranslateValues) => string;

export function createLanguagesTableColumns(
  t: TranslateFn,
): ColumnDefinition<Language>[] {
  return [
    {
      id: "flag",
      label: t("pro.system.localization.col.flag"),
      render: (row) =>
        row.flagUrl ? (
          <img
            src={row.flagUrl}
            alt=""
            width={28}
            height={18}
            style={{ objectFit: "cover", borderRadius: 3, display: "block" }}
          />
        ) : (
          <span style={{ color: "var(--color-fgMuted)" }}>—</span>
        ),
    },
    {
      id: "name",
      label: t("pro.system.localization.col.name"),
      sortable: true,
      pinnedLeft: true,
      render: (row) => row.name,
    },
    {
      id: "code",
      label: t("pro.system.localization.col.code"),
      sortable: true,
      render: (row) => (
        <span style={{ fontFamily: "monospace", fontSize: 13 }}>{row.code}</span>
      ),
    },
    {
      id: "description",
      label: t("pro.system.localization.col.description"),
      render: (row) => row.description || (
        <span style={{ color: "var(--color-fgMuted)" }}>—</span>
      ),
    },
    {
      id: "enabled",
      label: t("pro.system.localization.col.status"),
      render: (row) => (
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            padding: "1px 7px",
            borderRadius: 9999,
            background: row.enabled ? "#ECFDF5" : "#F3F4F6",
            color: row.enabled ? "#059669" : "#6B7280",
            border: `1px solid ${row.enabled ? "#A7F3D0" : "#E5E7EB"}`,
          }}
        >
          {row.enabled
            ? t("pro.system.localization.status.enabled")
            : t("pro.system.localization.status.disabled")}
        </span>
      ),
    },
  ];
}
